<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>

          <b-row>
            <b-col sm="12">
              <b-card header-class="redmfu">
                <div slot="header">
                  <strong v-if="thai_student==1">ตอนที่ 2 สำหรับผู้มีงานทำ</strong>
                  <strong v-else>Part 2 For Employed graduates</strong>
                  <div style="float:right;"
                  >
                    <b-badge pill variant="warning" class="font-sm text-dark p-2 pr-3 pl-3">Session Timeout :
                      {{ this.$store.state.timeExp }}
                    </b-badge>
                  </div>
                </div>
                <div v-for="item3 in item3s" v-bind:key="item3.QUESTION_PK">
                  <!--                  {{ item3.QUESTION_PK }}-->
                  <p v-if="item3.QUESTION_PK>=24 && item3.QUESTION_PK<=32 ">
                    <b-form-group
                      class="text-danger"
                      v-if="(items2[item3.QUESTION_PK-24].VALUES ==2)"
                      :label="'*  ' +item3.NUMBER  + ') '+item3.QUESTION_NAME"
                      label-for="basicInlineRadios"
                      :label-cols="12"
                    ></b-form-group>
                    <b-form-group
                      v-else
                      :label="item3.NUMBER  + ') '+item3.QUESTION_NAME"
                      label-for="basicInlineRadios"
                      :label-cols="12"
                    ></b-form-group>
                  </p>
                  <p v-else-if="item3.QUESTION_PK==33 ">
                    <!--                    {{ item3.NUMBER }})-->
                    <!--                    {{ item3.QUESTION_NAME }}-->
                    <b-form-group
                      class="text-danger"
                      v-if="(items2[item3.QUESTION_PK-24].VALUES ==2)"
                      :label="'*  ' +item3.NUMBER  + ') '+item3.QUESTION_NAME"
                      label-for="basicInlineRadios"
                      :label-cols="12"
                    ></b-form-group>
                    <b-form-group
                      v-else
                      :label="item3.NUMBER  + ') '+item3.QUESTION_NAME"
                      label-for="basicInlineRadios"
                      :label-cols="12"
                    ></b-form-group>
                  </p>
                  <b-form-group
                    label-cols-sm="1"
                    label
                    label-align-sm="right"
                    label-for="nested-street"
                  >
                    <b-form-input
                      v-if="item3.CONTROL_Q==1 && item3.QUESTION_PK=='24'"
                      id="current_salary"
                      type="email"
                      autocomplete="current_salary"
                      v-model="current_salary"
                      maxlength=7
                      :state="validation_salary"
                    ></b-form-input>
                    <b-form-group v-if=" item3.QUESTION_PK=='24'"
                                  label="No Comma “,” for example 20000 "
                                  :label-cols="12"></b-form-group>
                    <b-form-invalid-feedback v-if=" item3.QUESTION_PK=='24'" :state="validation_salary">
                      Your salary must be 4-7 characters long.
                    </b-form-invalid-feedback>
                    <b-form-valid-feedback v-if=" item3.QUESTION_PK=='24'" :state="validation_salary">
                      Correct.
                    </b-form-valid-feedback>


                    <b-form-radio-group
                      v-if="item3.QUESTION_PK==25"
                      v-model="selected_work_satisfy"
                      value-field="BYTECODE"
                      text-field="BYTEDES"
                      :options="item3s[1].ANS"
                      stacked
                      name="selected_work_satisfy"
                    >
                      <b-form-input
                        v-if="selected_work_satisfy=='0'"
                        id="qn_work_satisfy_txt"
                        type="text"
                        autocomplete="qn_work_satisfy_txt"
                        v-model="qn_work_satisfy_txt"
                        placeholder="Other..."
                      ></b-form-input>
                    </b-form-radio-group>
                    <b-form-radio-group
                      v-if="item3.QUESTION_PK==26"
                      v-model="selected_time_findwork"
                      value-field="BYTECODE"
                      text-field="BYTEDES"
                      :options="item3s[2].ANS"
                      stacked
                      name="selected_time_findwork"
                    >
                    </b-form-radio-group>
                    <b-form-radio-group
                      v-if="item3.QUESTION_PK==27"
                      v-model="selected_match_edu"
                      value-field="BYTECODE"
                      text-field="BYTEDES"
                      :options="item3s[3].ANS"
                      stacked
                      name="selected_match_edu"
                    >
                    </b-form-radio-group>
                    <b-form-radio-group
                      v-if="item3.QUESTION_PK==28"
                      v-model="selected_apply_edu"
                      value-field="BYTECODE"
                      text-field="BYTEDES"
                      :options="item3s[4].ANS"
                      stacked
                      name="selected_apply_edu"
                    >
                    </b-form-radio-group>
                    <b-form-radio-group
                      v-if="item3.QUESTION_PK==30"
                      v-model="selected_work_success1"
                      value-field="BYTECODE"
                      text-field="BYTEDES"
                      :options="item3s[6].ANS"
                      stacked
                      name="selected_work_success1"
                    >
                      <b-form-input
                        v-if="selected_work_success1=='0'"
                        id="qn_work_success1_txt"
                        type="text"
                        autocomplete="qn_work_success1_txt"
                        v-model="qn_work_success1_txt"
                        placeholder="Other..."
                      ></b-form-input>
                    </b-form-radio-group>
                    <b-form-radio-group
                      v-if="item3.QUESTION_PK==31"
                      v-model="selected_work_success2"
                      value-field="BYTECODE"
                      text-field="BYTEDES"
                      :options="item3s[7].ANS"
                      stacked
                      name="selected_work_success2"
                    >

                      <b-form-input
                        v-if="selected_work_success2=='0'"
                        id="qn_work_success2_txt"
                        type="text"
                        autocomplete="qn_work_success2_txt"
                        v-model="qn_work_success2_txt"
                        placeholder="Other..."
                      ></b-form-input>
                    </b-form-radio-group>
                    <b-form-radio-group
                      v-if="item3.QUESTION_PK==32"
                      v-model="selected_work_success3"
                      value-field="BYTECODE"
                      text-field="BYTEDES"
                      :options="item3s[8].ANS"
                      stacked
                      name="selected_work_success3"
                    >
                      <b-form-input
                        v-if="selected_work_success3=='0'"
                        id="qn_work_success3_txt"
                        type="text"
                        autocomplete="qn_work_success3_txt"
                        v-model="qn_work_success3_txt"
                        placeholder="Other..."
                      ></b-form-input>
                    </b-form-radio-group>

                    <b-form-radio-group
                      v-if="item3.QUESTION_PK==33"
                      v-model="selected_require_edu"
                      value-field="BYTECODE"
                      text-field="BYTEDES"
                      :options="item3s[9].ANS"
                      stacked
                      name="selected_require_edu"
                    >
                    </b-form-radio-group>
                  </b-form-group>
                </div>
                <div slot="footer" class="text-center">
                  <b-button type="submit" size="md" class="mr-2" variant="success" @click="onBack">
                    <i class="fa fa-arrow-circle-o-left"></i> Back
                  </b-button>
                  <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onSubmit">
                    <i class="fa fa-dot-circle-o"></i> Submit
                  </b-button>

                  <b-button type="reset" size="md" class="mr-2" variant="danger" @click="onReset">
                    <i class="fa fa-ban"></i> Reset
                  </b-button>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6"></b-col>
      </b-row>
    </div>

    <b-modal v-if="thai_student==1"
             title="คุณกรอกข้อมูลไม่ครบถ้วน"
             class="modal-danger"
             v-model="dangerModal"
             @ok="dangerModal = false"
             ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
    <b-modal v-if="thai_student==0"
             title="You didn’t fill your information completely"
             class="modal-danger"
             v-model="dangerModal"
             @ok="dangerModal = false"
             ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {YimoVueEditor},
  name: "CreateGeneral",
  data() {
    return {
      number: 0,
      number20: 0,
      number21: 0,
      number22: 0,
      number23: 0,
      student: {},
      std_id: "",
      // selected_occup_type: "",
      // selected_mfii: "",
      // qn_mfii_txt: "",
      // selected_talent: "",
      // current_department_name: "",
      // selected_work_type: "",
      // qn_occup_type_txt: "",
      qn_work_status: "",
      // qn_talent_txt: "",
      selected_work_satisfy: "",
      qn_work_satisfy_txt: "",
      selected_time_findwork: "",
      selected_match_edu: "",
      selected_apply_edu: "",
      select_other: 0,
      selected_work_success1: "",
      selected_work_success2: "",
      selected_work_success3: "",
      qn_work_success1_txt: "",
      qn_work_success2_txt: "",
      qn_work_success3_txt: "",
      selected_require_edu: "",
      sex: "",
      thai_student: "",
      current_erorrtxt: "",
      dangerModal: false,
      // current_position: "",
      // current_no: "",
      // current_village: "",
      // current_moo: "",
      // current_lane: "",
      // current_road: "",
      // current_zipcode: "",
      // current_address: "",
      // current_building: "",
      // current_tel: "",
      // current_fax: "",
      // current_email: "",
      current_salary: "",
      // items: [],
      // item1s: [],
      items2: [],
      // item2s: [],
      item3s: [],
      // current_office: "",
      // select_position: 0,
      // select_position1: "",
      // positionItems: [],
      // select_country_name: "",
      // countryItems: [],
      // select_province: 0,
      // provinceItems: [],
      // select_district: 0,
      // districtItems: [],
      // select_subdistrict: 0,
      // select_subdistrict_name: "",
      // subdistrictItems: [],
      // select_country: "",
      // select_country1: "",
      actionUpdate: 10,
      w_success1: 0,
      w_success2: 0,
      w_success3: 0,
    };
  }, computed: {
    validation_salary() {
      var comma_string = ",";
      var string_length = 0;
      if ((this.current_salary != null) && (this.current_salary != undefined)) {
        if (this.current_salary.toString().length>0){
        var string_salary = this.current_salary.toString();
        string_length = this.current_salary.toString().length;
        if ((string_length >= 4) && (string_length <= 7)) {
          if (string_salary.includes(comma_string)) {
            return false;
          } else {
            if ((this.current_salary>=1000)&&(this.current_salary<=999999999)){
              return true;
            } else {
              return false;
            }
          }
        } else {
          return false;
        }
        }else{
          return false;
        }
      } else {
        return false;
      }
    },
  },
  // components: {
  //   vSelect
  // },
  methods: {
    onBack() {
      this.$router.push("/part2_2");
    },
    validSalary() {

      // var salary3 = /^\d{3}$/;
      // var salary4 = /^\d{4}$/;
      // var salary5 = /^\d{5}$/;
      // var salary6 = /^\d{6}$/;
      // var salary7 = /^\d{7}$/;
      // console.log("salary3==", this.current_salary.match(salary3));

      /*if (this.current_salary.match(salary3) || this.current_salary.match(salary4) || this.current_salary.match(salary5) || this.current_salary.match(salary6) || this.current_salary.match(salary7)) {
        // console.log("true==", this.current_salary);
        return true;
      } else {
        // console.log("false==", this.current_salary);
        return false;
      } */
    },
    isNumeric: function (n) {
      if ((n > 999) || (n <= 9999999)) {
        return true;
      } else {
        return false;
      }
    },
    // wrongNumber: function () {
    //   //  this.isNumeric(this.current_salary) == false
    //   //  console.log("-------wrongNumber----------",this.isNumeric(this.current_salary));
    //   return this.isNumeric(this.current_salary);
    // },
    getCurrentStudent(studentid) {
      api
        .getStudentGeneral(studentid)
        .then(res => {
          // console.log("-------res----------",res.data.data);
          if (res.data.data.length > 0) {
            this.actionUpdate = 1;
            var currentSt = res.data.data[0];
            this.std_id = this.student.STUDENTID;
            this.qn_work_status = currentSt.QN_WORK_STATUS;

            this.current_salary = currentSt.QN_SALARY;
            this.selected_work_satisfy = currentSt.QN_WORK_SATISFY;
            this.qn_work_satisfy_txt = currentSt.QN_WORK_SATISFY_TXT;
            this.selected_time_findwork = currentSt.QN_TIME_FINDWORK;
            this.selected_match_edu = currentSt.QN_MATCH_EDU;
            this.selected_apply_edu = currentSt.QN_APPLY_EDU;
            this.selected_work_success1 = currentSt.WORK_SUCCESS1;
            this.selected_work_success2 = currentSt.WORK_SUCCESS2;
            this.selected_work_success3 = currentSt.WORK_SUCCESS3;

            this.qn_work_success1_txt = currentSt.WORK_SUCCESS_TEXT1;
            this.qn_work_success2_txt = currentSt.WORK_SUCCESS_TEXT2;
            this.qn_work_success3_txt = currentSt.WORK_SUCCESS_TEXT3;
            this.selected_require_edu = currentSt.QN_REQUIRE_EDU;
          } else {
            this.actionUpdate = 0;
          }
          return this.actionUpdate;
        })
        .catch(err => {
          this.actionUpdate = 10;
          console.log("getCurrentStudent", err.toString());
          // this.$router.push("Logout");
        });
      // console.log("actionUpdate==", this.actionUpdate);
    },
    getStudentQuestion() {
      this.std_id = this.$store.state.user.studentid;
      this.stdstudentId = this.$store.state.user.studentid;
      this.thai_student = this.$store.state.user.thaistudent;
      this.sex = this.$store.state.user.sex;
      // var start = parseInt(this.$route.query.x);
      // const x = parseInt(this.$route.query.x);
      // const start = x > 0 ? x : 0;
      var x = this.$route.query.x;
      var start = 0;
      console.log("x==", isNaN(x));
      if (isNaN(x) || x <= 0) {
        start = 0;
      } else {
        start = parseInt(x);
      }
      this.getQuestion(23, this.sex, this.thai_student, start);
    },
    setStudent() {
      var student = {};
      student.std_id = this.$store.state.user.studentid;
      student.qn_year = this.$store.state.user.year;
      student.current_salary = this.current_salary;
      if ((this.current_salary == null) || (this.current_salary == '') || (this.current_salary == undefined)) {
        this.items2[0].VALUES = 2;
      } else {
        this.items2[0].VALUES = 1;
      }
      student.selected_work_satisfy = this.selected_work_satisfy;
      if (this.selected_work_satisfy == 0) {
        student.qn_work_satisfy_txt = this.qn_work_satisfy_txt
        //.replaceAll( "'", "`");
      } else {
        student.qn_work_satisfy_txt = "";
      }
      if ((this.selected_work_satisfy == null) || (this.selected_work_satisfy == '') || (this.selected_work_satisfy == undefined)) {
        this.items2[1].VALUES = 2;
      } else {
        if ((this.selected_work_satisfy == 0) && ((this.qn_work_satisfy_txt == null) || (this.qn_work_satisfy_txt == '') || (this.qn_work_satisfy_txt == undefined))) {
          this.items2[1].VALUES = 2;
        } else {
          this.items2[1].VALUES = 1;
        }
      }
      student.selected_time_findwork = this.selected_time_findwork;
      if ((this.selected_time_findwork == null) || (this.selected_time_findwork == '') || (this.selected_time_findwork == undefined)) {
        this.items2[2].VALUES = 2;
      } else {
        this.items2[2].VALUES = 1;
      }
      student.selected_match_edu = this.selected_match_edu;
      if ((this.selected_match_edu == null) || (this.selected_match_edu == '') || (this.selected_match_edu == undefined)) {
        this.items2[3].VALUES = 2;
      } else {
        this.items2[3].VALUES = 1;
      }
      student.selected_apply_edu = this.selected_apply_edu;
      if ((this.selected_apply_edu == null) || (this.selected_apply_edu == '') || (this.selected_apply_edu == undefined)) {
        this.items2[4].VALUES = 2;
      } else {
        this.items2[4].VALUES = 1;
      }
      student.selected_work_success1 = this.selected_work_success1;
      if ((this.selected_work_success1 == null) || (this.selected_work_success1 == '') || (this.selected_work_success1 == undefined)) {
        this.items2[6].VALUES = 2;
      } else {
        this.items2[6].VALUES = 1;
      }
      student.selected_work_success2 = this.selected_work_success2;
      if ((this.selected_work_success2 == null) || (this.selected_work_success2 == '') || (this.selected_work_success2 == undefined)) {
        this.items2[7].VALUES = 2;
      } else {
        this.items2[7].VALUES = 1;
      }
      student.selected_work_success3 = this.selected_work_success3;
      if ((this.selected_work_success3 == null) || (this.selected_work_success3 == '') || (this.selected_work_success3 == undefined)) {
        this.items2[8].VALUES = 2;
      } else {
        this.items2[8].VALUES = 1;
      }
      if (this.selected_work_success1 > 0) {
        student.qn_work_success1_txt = "";
      } else {
        student.qn_work_success1_txt = this.qn_work_success1_txt
      }
      if (this.selected_work_success2 > 0) {
        student.qn_work_success2_txt = "";
      } else {
        student.qn_work_success2_txt = this.qn_work_success2_txt
      }
      if (this.selected_work_success3 > 0) {
        student.qn_work_success3_txt = "";
      } else {
        student.qn_work_success3_txt = this.qn_work_success3_txt
      }
      student.selected_require_edu = this.selected_require_edu;
      if ((this.selected_require_edu == null) || (this.selected_require_edu == '') || (this.selected_require_edu == undefined)) {
        this.items2[9].VALUES = 2;
      } else {
        this.items2[9].VALUES = 1;
      }
      // console.log("setStudent==", student);
      return student;
    },
    checkQuotation(s) {
      var quotation1 = "'";
      var quotation2 = "`";

      if (s.qn_work_satisfy_txt != '' && s.qn_work_satisfy_txt != null && s.qn_work_satisfy_txt != undefined) {
        if (s.qn_work_satisfy_txt.toString().length > 0) {
          if (s.qn_work_satisfy_txt.toString().includes(quotation1)) {
            s.qn_work_satisfy_txt = s.qn_work_satisfy_txt.replaceAll(quotation1, "''");
          }
          if (s.qn_work_satisfy_txt.toString().includes(quotation2)) {
            s.qn_work_satisfy_txt = s.qn_work_satisfy_txt.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.qn_work_success1_txt != '' && s.qn_work_success1_txt != null && s.qn_work_success1_txt != undefined) {
        if (s.qn_work_success1_txt.toString().length > 0) {
          if (s.qn_work_success1_txt.toString().includes(quotation1)) {
            s.qn_work_success1_txt = s.qn_work_success1_txt.replaceAll(quotation1, "''");
          }
          if (s.qn_work_success1_txt.toString().includes(quotation2)) {
            s.qn_work_success1_txt = s.qn_work_success1_txt.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.qn_work_success2_txt != '' && s.qn_work_success2_txt != null && s.qn_work_success2_txt != undefined) {
        if (s.qn_work_success2_txt.toString().length > 0) {
          if (s.qn_work_success2_txt.toString().includes(quotation1)) {
            s.qn_work_success2_txt = s.qn_work_success2_txt.replaceAll(quotation1, "''");
          }
          if (s.qn_work_success2_txt.toString().includes(quotation2)) {
            s.qn_work_success2_txt = s.qn_work_success2_txt.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.qn_work_success3_txt != '' && s.qn_work_success3_txt != null && s.qn_work_success3_txt != undefined) {
        if (s.qn_work_success3_txt.toString().length > 0) {
          if (s.qn_work_success3_txt.toString().includes(quotation1)) {
            s.qn_work_success3_txt = s.qn_work_success3_txt.replaceAll(quotation1, "''");
          }
          if (s.qn_work_success3_txt.toString().includes(quotation2)) {
            s.qn_work_success3_txt = s.qn_work_success3_txt.replaceAll(quotation2, "''");
          }
        }
      }
      return s;
    },
    checkWorkSucces(s){

    },
    getErrorTxt: function (s) {
      this.current_erorrtxt = "";
      var substring = "--";
      var substring2 = "-";
      var zerochar = "00000";
      // console.log("Before items2==",this.items2)
      this.numEror = 0;

      var student = this.checkQuotation(s);
      if (this.current_salary <= 999) {
        this.numEror = this.numEror + 1;
        this.items2[0].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/เงินเดือนมากกว่า 999" : this.current_erorrtxt + "/Revenue per month /Please put only the amount. Do not put a ,  comma.";
      }
      if ((this.current_salary == null) || (this.current_salary == "") || (this.current_salary == undefined)) {
        this.numEror = this.numEror + 1;
        this.items2[0].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/เงินเดือน" : this.current_erorrtxt + "/Revenue per month /Please put only the amount. Do not put a ,  comma.";
      }
      if (this.current_salary != '' && this.current_salary != 0 && this.current_salary != null && this.current_salary != undefined) {
        if (this.current_salary.toString().length > 0) {
          if (!this.isNumeric(this.current_salary)) {
            this.numEror = this.numEror + 1;
            this.items2[0].VALUES = 2;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/เงินเดือนเป็นตัวเลข" : this.current_erorrtxt + "/Please put only the amount. Do not put a ,  comma.";
          }
        }
      }
      if ((this.selected_work_satisfy == null) || (this.selected_work_satisfy == "")) {
        this.numEror = this.numEror + 1;
        this.items2[1].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ความพอใจต่องานที่ทำ" : this.current_erorrtxt + "/Work satisfy";
      }
      if ((this.selected_work_satisfy == "0") && ((this.qn_work_satisfy_txt == "") || (this.qn_work_satisfy_txt == "None") || (this.qn_work_satisfy_txt == null) || (this.qn_work_satisfy_txt == "-") || (this.qn_work_satisfy_txt == "/"))) {
        this.numEror = this.numEror + 1;
        this.items2[1].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ความพอใจต่องานที่ทำ" : this.current_erorrtxt + "/Other Work satisfy";
      } else if ((this.selected_work_satisfy == "0") && ((this.qn_work_satisfy_txt != ""))) {
        if (this.qn_work_satisfy_txt.includes(substring)) {
          this.numEror = this.numEror + 1;
          this.items2[1].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆความพอใจต่องานที่ทำ --" : this.current_erorrtxt + "/Other Work satisfy --";
        }
      }
      if ((this.selected_time_findwork == null) || (this.selected_time_findwork == "")) {
        this.numEror = this.numEror + 1;
        this.items2[2].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ระยะเวลาหางาน" : this.current_erorrtxt + "/Time findwork";
      }
      if ((this.selected_match_edu == null) || (this.selected_match_edu == "")) {
        this.numEror = this.numEror + 1;
        this.items2[3].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/งานตรงตามกับสาขา" : this.current_erorrtxt + "/Match education";
      }
      if ((this.selected_apply_edu == null) || (this.selected_apply_edu == "")) {
        this.numEror = this.numEror + 1;
        this.items2[4].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ประยุกต์กับงาน" : this.current_erorrtxt + "/Apply education";
      }
   /*   if (
        (this.selected_work_success1 == this.selected_work_success2) ||
        (this.selected_work_success2 == this.selected_work_success3) ||
        (this.selected_work_success1 == this.selected_work_success3)) {
        // console.log("yyy--", this.selected_work_success1, "--", this.selected_work_success2, "--", this.selected_work_success3);

        if (((this.selected_work_success1 == 0) && (this.selected_work_success2 == 0)) ||
          ((this.selected_work_success1 == 0) && (this.selected_work_success3 == 0)) ||
          ((this.selected_work_success2 == 0) && (this.selected_work_success3 == 0))) {
          this.select_other = 10;
        } else {
          this.numEror = this.numEror + 1;
          this.items2[6].VALUES = 2;
          this.items2[7].VALUES = 2;
          this.items2[8].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/เลือกปัจจัยซ้ำกัน" : this.current_erorrtxt + "/Please rank the three most important things, the first one is the most important and so on";
        }
      }*/
      if (this.selected_work_success1 == 0) {
        this.w_success1 = 0;
        if ((this.qn_work_success1_txt != null) && (this.qn_work_success1_txt.includes(substring))) {
          this.w_success1 = this.w_success1 + 1;
        }
        if (this.qn_work_success1_txt == null || this.qn_work_success1_txt == "" ||
          this.qn_work_success1_txt == undefined || this.qn_work_success1_txt == "None" ||
          this.qn_work_success1_txt == substring2 || this.qn_work_success1_txt == "/" ) {
          this.w_success1 = this.w_success1 + 1;
        }
        if (this.w_success1 != 0) {
          this.numEror = this.numEror + 1;
          this.items2[6].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ ปัจจัยที่สำคัญลำดับที่ 1 อื่นๆ โปรดระบุ" : this.current_erorrtxt + "/The first important thing Others (Please specify)";
        }
      }
      if (this.selected_work_success2 == 0) {
        this.w_success2 = 0;
        if ((this.qn_work_success2_txt != null) && (this.qn_work_success2_txt.includes(substring))) {
          this.w_success2 = this.w_success2 + 1;
        }
        if (this.qn_work_success2_txt == null || this.qn_work_success2_txt == "" ||
          this.qn_work_success2_txt == undefined || this.qn_work_success2_txt == "None" ||
          this.qn_work_success2_txt == substring2 || this.qn_work_success2_txt == "/" ) {
          this.w_success2 = this.w_success2 + 1;
        }
        if (this.w_success2 != 0) {
          this.numEror = this.numEror + 1;
          this.items2[7].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ ปัจจัยที่สำคัญลำดับที่ 2 อื่นๆ โปรดระบุ" : this.current_erorrtxt + "/The second important thing Others (Please specify)";
        }
      }
      if (this.selected_work_success3 == 0) {
        this.w_success3 = 0;
        if ((this.qn_work_success3_txt != null) && (this.qn_work_success3_txt.includes(substring))) {
          this.w_success3 = this.w_success3 + 1;
        }
        if (this.qn_work_success3_txt == null || this.qn_work_success3_txt == "" ||
          this.qn_work_success3_txt == undefined || this.qn_work_success3_txt == "None" ||
          this.qn_work_success3_txt == substring2 || this.qn_work_success3_txt == "/") {
          this.w_success3 = this.w_success3 + 1;
        }
        if (this.w_success3 != 0) {
          this.numEror = this.numEror + 1;
          this.items2[8].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ ปัจจัยที่สำคัญลำดับที่ 3 อื่นๆ โปรดระบุ" : this.current_erorrtxt + "/The third important thing  Others (Please specify)";
        }
      }

      if (this.selected_work_success1 == 0 && this.selected_work_success2 == 0 && this.selected_work_success3 == 0){
        if ((this.qn_work_success1_txt == this.qn_work_success2_txt) && (this.qn_work_success2_txt == this.qn_work_success3_txt)) {
          this.numEror = this.numEror + 1;
          this.items2[6].VALUES = 2;
          this.items2[7].VALUES = 2;
          this.items2[8].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ปัจจัยที่สำคัญลำดับที่ 1,2,3 อื่นๆ ซ้ำกัน" : this.current_erorrtxt + "/Others (Please specify)";

        } else if (this.qn_work_success1_txt == this.qn_work_success2_txt) {
          if ((this.selected_work_success1 == 0) && (this.selected_work_success2 == 0)) {
            this.numEror = this.numEror + 1;
            this.items2[6].VALUES = 2;
            this.items2[7].VALUES = 2;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ปัจจัยที่สำคัญลำดับที่ 1,2 อื่นๆ ซ้ำกัน" : this.current_erorrtxt + "/Others (Please specify)";
          }
        } else if ((this.qn_work_success1_txt == this.qn_work_success3_txt)) {
          if ((this.selected_work_success1 == 0) && (this.selected_work_success3 == 0)) {
            this.numEror = this.numEror + 1;
            this.items2[6].VALUES = 2;
            this.items2[8].VALUES = 2;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ปัจจัยที่สำคัญลำดับที่ 1,3 อื่นๆ ซ้ำกัน" : this.current_erorrtxt + "/Others (Please specify)";
          }
        } else if ((this.qn_work_success3_txt == this.qn_work_success2_txt)) {
          if ((this.selected_work_success3 == 0) && (this.selected_work_success2 == 0)) {
            this.numEror = this.numEror + 1;
            this.items2[7].VALUES = 2;
            this.items2[8].VALUES = 2;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ปัจจัยที่สำคัญลำดับที่ 2,3 อื่นๆ ซ้ำกัน" : this.current_erorrtxt + "/Others (Please specify)";
          }
        }
    }else{
        if (this.selected_work_success1 ==this.selected_work_success2 && this.selected_work_success1 ==this.selected_work_success3 ){
          this.numEror = this.numEror + 1;
          this.items2[7].VALUES = 2;
          this.items2[8].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/เลือกปัจจัยซ้ำกัน 1,2,3 ซ้ำกัน" : this.current_erorrtxt + "/1,2,3 Please rank the three most important things, the first one is the most important and so on";
        }else if (this.selected_work_success1 ==this.selected_work_success2 ){
          this.numEror = this.numEror + 1;
          this.items2[7].VALUES = 2;
          this.items2[8].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/เลือกปัจจัยซ้ำกัน 1,2 ซ้ำกัน" : this.current_erorrtxt + "/1,2 Please rank the three most important things, the first one is the most important and so on";
        }else if (this.selected_work_success1 ==this.selected_work_success3 ){
          this.numEror = this.numEror + 1;
          this.items2[7].VALUES = 2;
          this.items2[8].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/เลือกปัจจัยซ้ำกัน 1,3 ซ้ำกัน" : this.current_erorrtxt + "/1,3 Please rank the three most important things, the first one is the most important and so on";
        }else if (this.selected_work_success2 ==this.selected_work_success3 ){
          this.numEror = this.numEror + 1;
          this.items2[7].VALUES = 2;
          this.items2[8].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/เลือกปัจจัยซ้ำกัน 2,3 ซ้ำกัน" : this.current_erorrtxt + "/2,3 Please rank the three most important things, the first one is the most important and so on";
        }

      }
      if ((this.selected_require_edu == null) || (this.selected_require_edu == "")) {
        this.numEror = this.numEror + 1;
        this.items2[9].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/การศึกษาต่อ" : this.current_erorrtxt + "/Require education";
      }
      // console.log("Before items2==", this.items2)
      if (this.numEror == 0) {
        this.dangerModal = false;
      } else {
        this.dangerModal = true;
      }
      student.num_error= this.numEror;
      return student;
    },
    nextPart() {
      if (this.selected_require_edu == 1) {
        this.$router.push("/part4?x=" + this.number);
      } else if (this.selected_require_edu == 2) {
        this.$router.push("/part5?x=" + this.number);
      }
    },
    updatePart2_3(student) {
      api
        .updateStudentPart2_3(student)
        .then(res => {
          // console.log(this.student);
          this.message = res.message;
          if (res.data.code == 200) {
            // console.log("update ผ่าน", this.std_id);
            this.nextPart();
          } else {

          }

        })
        .catch(err => {
          console.log("updatePart2 error", err.toString());
          // this.$router.push("Logout");
        });
    },
    onReset() {
      this.current_salary = "";//24
      this.selected_work_satisfy = "";//25
      this.qn_work_satisfy_txt = "";
      this.selected_time_findwork = "";//26
      this.selected_match_edu = "";//27
      this.selected_apply_edu = "";//28
      this.selected_work_success1 = ""; //30
      this.qn_work_success1_txt = "";
      this.selected_work_success2 = ""; //31
      this.qn_work_success2_txt = "";
      this.selected_work_success3 = ""; //32
      this.qn_work_success3_txt = "";
      this.selected_require_edu = "";//33

    }
    ,
    onSubmit() {
      var student = {}
      student = this.setStudent();
      var s = this.getErrorTxt(student);
      // console.log("this.student", this.student);
      if (s.num_error == 0) {
        if (this.actionUpdate == 1) {
          this.updatePart2_3(s);
        } else {
          this.$router.push("/general");
        }
      }

      // console.log("ansChoose=", this.ansChoose);
    },
    getQuestion(section, sex, thaistudent, start) {
      api
        .getQuestionBySection(section, sex, thaistudent, start)
        .then(res => {
          var number;
          number = start;
          // console.log("section==", res)
          var length = res.data.data.length;
          this.number = start + length;
          var number29 = 0;
          for (var i = 0; i < res.data.data.length; i++) {


            if (res.data.data[i].QUESTION_PK == 29) {
              number = number + 1;
              number29 = number;
              res.data.data[i].NUMBER = number29;
            } else if (res.data.data[i].QUESTION_PK == 30) {
              res.data.data[i].NUMBER = number29 + ".1"
            } else if (res.data.data[i].QUESTION_PK == 31) {
              res.data.data[i].NUMBER = number29 + ".2"
            } else if (res.data.data[i].QUESTION_PK == 32) {
              res.data.data[i].NUMBER = number29 + ".3"
            } else if (res.data.data[i].QUESTION_PK == 33) {
              res.data.data[i].NUMBER = number29 + 1;
              this.number = number29 + 1;
            } else {
              number = number + 1;
              res.data.data[i].NUMBER = number;
            }
            // console.log("section==", this.number)
          }
          this.item3s = res.data.data;
        })
        .catch(err => {
          console.log("2_3 getQuestion", err.toString());
        });

    },
  },
  mounted() {
  }
  ,
  created() {
    for (var j = 24; j <= 33; j++) { //9 ข้อ
      var b = {ID: j, UPDATEDATA: 0, VALUES: 0}
      this.items2.push(b);
    }
    if (this.$store.state.token == null || this.$store.state.user == null) {
      this.$router.push("/Logout");
    } else {
      // this.$router.push("/Dashboard");
    }
    this.std_id = this.$store.state.user.studentid;
    api.onSetHeader();
    // console.log("store==", this.$store.state.user);
    this.actionUpdate = this.getCurrentStudent(this.std_id);
    // this.select_country = 41;
    this.getStudentQuestion();

  }
}
;
</script>
<style>
</style>
